import { Component, OnInit } from '@angular/core';
import { of, Subject, Subscription, throwError } from 'rxjs';
import { OrderArticulos } from '../../../../../../core/model/DataOrder';
import { ProductData } from '../../../../../../core/model/Product.model';
import { DataFactura } from '../../../../../../views/clientes/model/DataFactura';
import { CheckoutService } from '../../utils/services/checkout.service';
import { Router } from '@angular/router';
import { AccountStatusService } from '../../../../../../views/clientes/services/account-status/account-status.service';
import { SwalService } from '../../../../../../services/swal/swal.service';
import { CartService } from '../../../../../../services/generar-pedido/cart/cart.service';
import { LoginService } from '../../../../../../services/login/login.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SucursalPredeterminadaPipe } from '../../utils/pipes/sucursal-predeterminada.pipe';
import { EventService } from '../../../../../../services/event.service';
import { switchMap, takeUntil } from 'rxjs/operators';
import { DataResponseFacturas } from '../../utils/models/DataFactura';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { HeightCartService } from '../../utils/services/height-cart.service';

@Component({
  selector: 'app-boton-order',
  templateUrl: './boton-order.component.html',
  styleUrls: ['./boton-order.component.scss']
})
export class BotonOrderComponent implements OnInit {
  public botonOrder: string;
  private unsubscribe$ = new Subject<void>();
  public mensajeTooltip = '';
  public loading: boolean;
  public textoLoading: string = '';
  public disabled: boolean = true;
  public disabledTooltip: boolean = true;
  public dataFacturas: DataFactura[];
  public listProducts: ProductData[];
  private saldoVencido: number = 0;
  private tipoAlerta: string = ''; //Tooltip || Modal
  public orderArticulos: OrderArticulos;
  public pagarKabiCoin: boolean = false;
  public masProduct: boolean = false;
  private tipoCompra: string;

  public susOrderBtn: Subscription = null;
  public first: boolean = true;

  constructor(
    private service: CheckoutService,
    private router: Router,
    private account: AccountStatusService,
    private swalService: SwalService,
    private cartService: CartService,
    private loginService: LoginService,
    private matSnackBar: MatSnackBar,
    private almacenPre: SucursalPredeterminadaPipe,
    private eventService: EventService,
    private heightService: HeightCartService
  ) { }

  ngOnInit(): void {
    this.botonOrder = 'efectivo';
    this.getArticulosKabiCoins();
    this.disabledEnableButtonConfirmarPedido();

    this.susOrderBtn = this.eventService
      .get('updateOrderBtn')
      .subscribe((data: any) => {
        this.botonOrder = data.data;
        this.getArticulosKabiCoins();
        this.disabledEnableButtonConfirmarPedido();
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.susOrderBtn) {
      this.susOrderBtn.unsubscribe();
    }
  }

  private getArticulosKabiCoins() {
    this.cartService.cart$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((productData: ProductData[]) => {
        // //console.log(productData);
        if (productData) {
          productData.forEach((product) => {
            if (product.PagarConKabikCoin) {
              //  //console.log('PagarConKabiCoin****')
              this.pagarKabiCoin = true;
            }
            else {
              this.pagarKabiCoin = false;
            }
          });
        }
      });
  }

  //Habilita o inabilida el boton de confirmar pedido.
  private disabledEnableButtonConfirmarPedido() {
    this.disabled = true;
    this.loading = true;
    this.textoLoading = 'Validando información de compra y envió...';
    let errorTemp: boolean = false;
    let contadoCredito: string;
    let mensajeTooltipTemp: string = '';
    const almacenPredeterminado = this.almacenPre.transform('');
    this.orderArticulos = this.service.itemsOrder();
    // let envioPaqueteriaCedis:boolean = false;
    // let DatosEnvSucursal:boolean = false;
    /* Pos ya lo contrataron
     * Optenemos las facturas de los clientes,
     * Validamos que no tenga saldo vencido, si cuenta con saldo vencido no lo dejamos continuar a credito
     * y si es canje kabikcoins mostrarle la alerta de que su pedido no puede generarse
     * por que cuenta con saldo vencido.     this.service.getLimiteDeCredito$()
     */
    this.service
      .getLimiteDeCredito$()
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap(
          (limiteCredito: {
            creditoExcedido: boolean;
            mensaje: string;
            opcionTipoCompra: string;
          }) => {
            //console.warn('Limite 1 ', limiteCredito);
            this.loading = true;
            //console.log('disable1');

            this.disabled = true;
            contadoCredito = limiteCredito.opcionTipoCompra;
            this.tipoCompra = contadoCredito;
            this.textoLoading = 'Validando credito disponible...';
            if (limiteCredito.opcionTipoCompra === 'credito') {
              if (!limiteCredito.creditoExcedido) {
                // Valida que tenga el credito disponible
                errorTemp = false;
                return this.account
                  .getSaldoCliente(this.date())
                  .pipe(takeUntil(this.unsubscribe$));
              }
              /**
               * Error tiene credito excedido.
               * se debe de bloquear el boton y no se debe de dejar continuar.
               */
              errorTemp = true;
              mensajeTooltipTemp = limiteCredito.mensaje;
              return of({ message: mensajeTooltipTemp, error: true });
            } else if (limiteCredito.opcionTipoCompra === 'contado') {
              errorTemp = false;
              if (this.pagarKabiCoin) {
                // Si va pagar de contado los puntos kabiCoins revisar que no tenga saldo vencido
                return this.account
                  .getSaldoCliente(this.date())
                  .pipe(takeUntil(this.unsubscribe$));
              }
              // No realiza canje de puntos kabiCoins.
              return of({ message: 'tipo de compra contado', error: false });
            } else {
              errorTemp = true;
              mensajeTooltipTemp =
                'Para continuar debe seleccionar un tipo de compra';
              return of({
                message: 'Para continuar debe seleccionar un tipo de compra',
                error: true,
              });
            }
          }
        ),
        switchMap((Facturas: DataResponseFacturas) => {
          //console.warn('Limite 2 ', Facturas);
          this.loading = true;
          this.disabled = true;
          //console.log('disable2');
          if (!errorTemp) {
            this.textoLoading = 'Validando saldo disponible ...';
            if (Facturas) {
              // Si regresa informacion de las facturas.
              if (!Facturas?.error) {
                if (contadoCredito == 'credito' || this.pagarKabiCoin) {
                  this.dataFacturas = Facturas.data.dataFacturas;
                  this.saldoVencido = Facturas.data.saldoVencido;
                }
                errorTemp = false;
                return this.cartService.cart$.pipe(
                  takeUntil(this.unsubscribe$)
                );
              }
            } else {
              mensajeTooltipTemp =
                'Ocurrio un error al consultar las facturas, por favor intente seleccionado tipo de compra contado.';
              errorTemp = true;
              return of(null);
            }
          }
          // Retornamos el error del switch anterior. -
          errorTemp = true;
          return of(null);
        }),
        switchMap((Producto: ProductData[]) => {
          //console.warn('Limite 3 ', Producto);
          this.loading = true;
          this.disabled = true;
          //console.log('disable3');
          if (!errorTemp) {
            this.textoLoading = 'Consultado articulos de la cesta...';
            if (Producto) {
              // Consultamos los articulos del carrito para validar si tiene articulos con canje de kabiCoisn.
              this.listProducts = Producto;
              errorTemp = false;
              mensajeTooltipTemp = '';
              this.validaArticulosCanjesKabiCoins();
              return this.service
                .getMetodoPago$()
                .pipe(takeUntil(this.unsubscribe$));
            }
            /**Error al consultar los produtos de la cesta */
            errorTemp = true;
            mensajeTooltipTemp =
              'Ocurrio un error al consultar los productos de la cesta.';
            return of(null);
          }
          errorTemp = true;
          return of(null);
          //   throw new Error('Ocurrio un error al consultar los productos de la cesta.');
        }),
        switchMap(
          (metodoPago: {
            pagoSeleccionado: boolean;
            opcionPago: string;
            mensaje: string;
          }) => {
            //console.warn('Limite 4 ', metodoPago);
            this.loading = true;
            this.disabled = true;
            //console.log('disable4');
            if (!errorTemp) {
              this.textoLoading = 'Validando metodo de pago...';
              if (
                metodoPago.pagoSeleccionado &&
                (metodoPago.opcionPago === 'efectivo' ||
                  metodoPago.opcionPago === 'paypal' || metodoPago.opcionPago === 'santander')
              ) {
                errorTemp = false;
                mensajeTooltipTemp = '';
                this.botonOrder = metodoPago.opcionPago; // mostramos el componente
                //Regresamos los valores del metodo de entrega
                return this.service
                  .getEnvioMercanciaSucursal$()
                  .pipe(takeUntil(this.unsubscribe$));
              }
              // mensajeTooltipTemp ='Por favor selecione un metodo de pago.';
              if (contadoCredito === 'credito') {
                mensajeTooltipTemp =
                  'Para continuar selecione el método de pago: Pago en caja.';
              } else if (contadoCredito === 'contado') {
                mensajeTooltipTemp =
                  'Para continuar seleccione el método de pago: Pago en caja o Paypal.';
              }
              errorTemp = true;
              return of(null);
            }
            errorTemp = true;
            return of(null);
          }
        ),
        switchMap(
          (envioMercanciaSucursal: {
            direccionSeleccionada: boolean;
            opcionEnvio: string;
            mensaje: string;
            direccionEnvio: any;
          }) => {
            //console.warn('Limite 5 ', envioMercanciaSucursal);
            this.loading = true;
            this.disabled = true;
            //console.log('disable5');
            if (!errorTemp) {
              if (
                this.orderArticulos.CantidadArticulos
                  .CantidadDeArticulosSucursal > 0
              ) {
                this.textoLoading =
                  'Validando la forma de envio ' +
                  almacenPredeterminado +
                  '...';
                // //console.log('envio mercancia Cedis',envioMercanciaSucursal)
                if (envioMercanciaSucursal?.opcionEnvio == 'sucursal') {
                  errorTemp = false;
                  mensajeTooltipTemp = '';
                  return this.service
                    .getEnvioMercanciaCedis$()
                    .pipe(takeUntil(this.unsubscribe$));
                } else if (envioMercanciaSucursal?.opcionEnvio == 'envio' || envioMercanciaSucursal?.opcionEnvio == 'envioDomicilio') {
                  if (!envioMercanciaSucursal.direccionSeleccionada) {
                    errorTemp = true;
                    mensajeTooltipTemp = envioMercanciaSucursal.mensaje; //'Para continuar debe seleccione una dirección de envio.'
                    return of(null);
                  }
                  errorTemp = false;
                  mensajeTooltipTemp = '';
                  return this.service
                    .getEnvioMercanciaCedis$()
                    .pipe(takeUntil(this.unsubscribe$));
                } else {
                  errorTemp = true;
                  mensajeTooltipTemp =
                    'Para continuar debe seleccionar una forma de envio de la mercancía de ' +
                    almacenPredeterminado; //'Para continuar debe seleccione una dirección de envio.'
                  return of(null);
                }
              }
              if (
                this.orderArticulos.CantidadArticulos.CantidadDeArticulosCedis >
                0
              ) {
                return this.service
                  .getEnvioMercanciaCedis$()
                  .pipe(takeUntil(this.unsubscribe$));
              }
            }
            // errorTemp = true;
            return of(null);
          }
        ),
        switchMap(
          (envioMercanciaCedis: {
            direccionSeleccionada: boolean;
            opcionEnvio: string;
            mensaje: string;
            direccionEnvio: any;
          }) => {
            //console.warn('Limite 6', envioMercanciaCedis);
            this.loading = true;
            this.disabled = true;
            //console.log('disable6');
            if (!errorTemp) {
              if (
                this.orderArticulos.CantidadArticulos.CantidadDeArticulosCedis >
                0
              ) {
                this.textoLoading =
                  'Validando la forma de envio ' +
                  almacenPredeterminado +
                  '...';
                // //console.log('envio mercancia Cedis',envioMercanciaCedis)
                if (envioMercanciaCedis?.opcionEnvio == 'sucursal') {
                  errorTemp = false;
                  mensajeTooltipTemp = '';
                  return of('Ok, se completa la validacion de checkout');
                  // return this.service.getEnvioMercanciaCedis$().pipe(takeUntil(this.unsubscribe$));
                } else if (envioMercanciaCedis?.opcionEnvio == 'envio') {
                  if (!envioMercanciaCedis.direccionSeleccionada) {
                    errorTemp = true;
                    mensajeTooltipTemp = envioMercanciaCedis.mensaje; //'Para continuar debe seleccione una dirección de envio.'
                    return of(null);
                  }
                  return  of('Ok, se completa la validacion de checkout'); //this.service.getEnvioMercanciaCedis$().pipe(takeUntil(this.unsubscribe$));
                } else {
                  errorTemp = true;
                  mensajeTooltipTemp =
                    'Para continuar debe seleccionar una forma de envio de la mercancía de ' +
                    almacenPredeterminado; //'Para continuar debe seleccione una dirección de envio.'
                  return of(null);
                }
              }
            }
            // errorTemp = true;
            return of(null);
          }
        ),
        switchMap((response: any) => {
          this.loading = true;
          this.disabled = true;

          if (!errorTemp) {
            this.textoLoading = 'Validando estado ...';
            errorTemp = false;
            mensajeTooltipTemp = '';
            return  this.account
              .checkActivo()
              .pipe(takeUntil(this.unsubscribe$));
          }
          return of(null);

        }),
      switchMap((response: any) => {
        this.loading = true;
        this.disabled = true;
        if (!errorTemp) {
          console.log('response', response);
          if(response.baja === '1' || response.baja === 1){
            errorTemp = true;
            mensajeTooltipTemp =
              'La cuenta del cliente se encuentra inactiva. Comunicarse con el area de CXC para revisar el estado de cuenta.';
            return of(null);
          }
          return of('Ok, se completa la validacion de checkout');
        }
        return of(null);
      })).subscribe(
        (response) => {
          // //console.log('saldo vencido',this.saldoVencido)
          this.mensajeTooltip = mensajeTooltipTemp; // Mostramos el mesnaje del error
          this.tipoAlerta = 'Tooltip';
          if (this.loginService.isLogged()) {
            if (errorTemp) {
              // Ocurrio un error
              this.disabled = true;
              this.disabledTooltip = false;
              this.loading = false;
            } else if (
              contadoCredito === '' ||
              contadoCredito === undefined ||
              contadoCredito === null
            ) {
              this.disabled = true;
              this.disabledTooltip = false;
            } else {
              /// Validamos sus puntos kabiCoins dispnibles y que no tenga saldo vencido.
              if (
                this.saldoVencido > 0 &&
                this.pagarKabiCoin === true &&
                (contadoCredito === 'credito' || contadoCredito === 'contado')
              ) {
                this.mensajeTooltip =
                  'Estimado cliente, de momento su cuenta presenta saldo vencido, por lo que no puede realizar canjes de KabiCoins. Para cualquier aclaración favor de reportarlo al área de CXC al correo electrónico: <a href="mailto:cxc@kabik.com.mx">cxc@kabik.com.mx</a></p>';
                this.disabled = true;
                this.disabledTooltip = false;
                this.tipoAlerta = 'Modal';
                this.loading = false;
              } else {
                //Validamos las existencias
                const validar = this.cartService.validaExistencias$();
                console.log('validar=>', validar);
                // //console.log('validar=>',validar)
                if (
                  validar.existenciasCedis <= 0 &&
                  validar.existenciasSucursal <= 0
                ) {
                  // Validamos las existencias de los articulos
                  if (validar?.product?.length <= 0) {
                    this.mensajeTooltip =
                      'No se encontraron articulos en la cesta.';
                    this.disabled = true;
                    this.disabledTooltip = false;
                    this.loading = false;
                  } else if (
                    this.loginService.getDataClientePedido().permiso_comprar === 'NO'
                  ) {
                    this.mensajeTooltip =
                      'TU USUARIO NO TIENE PERMISOS PARA REALIZAR PEDIDOS. Para realizar esta acción, contacta al administrador de la cuenta para que te asigne el permiso.';
                    this.disabled = true;
                    this.disabledTooltip = false;
                    this.loading = false;
                    this.tipoAlerta = 'Modal';
                  } else if (
                    this.pagarKabiCoin === true &&
                    !this.loginService.getDataClientePedido().permiso_kabiCoins
                  ) {
                    // Si no tiene permisos para realizar el canje de puntos kabiCoins
                    this.mensajeTooltip =
                      'TU USUARIO NO TIENE PERMISOS PARA REALIZAR CANJE DE PUNTOS KABICOINS. Para realizar esta acción, contacta al administrador de la cuenta para que te asigne el permiso.';
                    this.disabled = true;
                    this.disabledTooltip = false;
                    this.loading = false;
                    this.tipoAlerta = 'Modal';
                  } else {
                    // Todo Ok Aqui entra excelente.
                    this.disabled = false;
                    this.disabledTooltip = true;
                    this.loading = false;
                  }
                } else {
                  this.mensajeTooltip =
                    'Los siguientes articulos no cuentan con existencias suficientes: ' +
                    validar.concactClaves.substring(
                      0,
                      validar.concactClaves.length - 1
                    );
                  this.disabled = true;
                  this.disabledTooltip = false;
                  this.tipoAlerta = 'Modal';
                  this.loading = false;
                }
              }
              mensajeTooltipTemp = '';
            }
          } else {
            //Sesion expiro
            this.mensajeTooltip =
              'Tu sesión ha expirado. Vuelve a iniciar sesión';
            this.disabled = true;
            this.disabledTooltip = false;
            this.loading = false;
          }
          // //console.group('****Reponse****')
          //   //console.log('el valor de error temp => ',errorTemp);
          //   //console.log('el valor de mensaje tooltip => ',mensajeTooltipTemp);
          //   //console.log('contadoCredito', contadoCredito)
          //   //console.log('disabled', this.disabled);
          //   //console.log('mensaje tootip',this.mensajeTooltip)
          //   //console.log(response);
          //  //console.groupEnd();
          this.textoLoading = '';
          errorTemp = false;
        },
        (error) => {
          //console.error(error);
        },
        () => {
        }
      );
  }



  public showAlert = () => {
    const cliente = this.loginService.getDataClientePedido();
    if (this.tipoAlerta == 'Tooltip') {
      this.matSnackBar.open(this.mensajeTooltip, 'Entendido', {
        duration: 10000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    } else if (this.tipoAlerta == 'Modal') {
      this.swalService.swalAlertKbCoin(
        'Tipo de compra a ' + this.tipoCompra,
        this.mensajeTooltip +
        '<br/><br/><div style="font-size: 14px;"><p>Número de cliente: ' +
        cliente.client_number +
        '<br/>Nombre: ' +
        cliente.company_name +
        '<br/>Correo electrónico: ' +
        cliente.email +
        '<br/>Almacén: ' +
        cliente.almacenPre +
        '</p></div>',
        false,
        '',
        'cxc@kabik.com.mx'
      );
      // tipoCompra
    } else {
      alert(this.mensajeTooltip);
    }
    //Estas validaciones se hacen antes de confirmar el pedido.
    if (!this.loginService.isLogged()) {
      localStorage.removeItem('items-cart-login-pg');
      const cartData = localStorage.getItem('items-cart-login');
      if (cartData) {
        localStorage.setItem('items-cart-login-pg', cartData);
        this.router.navigate(['iniciar_session/login/Y2xpZW50ZVB1YmxpY29HZW5lcmFs']);
      } else {
        this.router.navigate(['iniciar_session/login']);
      }
    }
    const validar = this.cartService.validaExistencias$();
    if (validar.existenciasCedis <= 0 && validar.existenciasSucursal <= 0) {
      if (validar?.product?.length <= 0) {
        this.router.navigate(['/']);
      }
    }
  };
  
  public click = (event: any) => {
    //console.warn('is evento', event);
    // Esta funcion bloquea todos el formulario del checkout
    // this.service.addformularioCheckout$(event);
    this.cartService.guardCheckout = true;
  };

  private validaArticulosCanjesKabiCoins = () => {
    // this.pagarKabiCoin = false;
    this.listProducts.forEach((product) => {
      if (product.PagarConKabikCoin) {
        this.pagarKabiCoin = true;
      }
      else {
        this.pagarKabiCoin = false;
      } /* else {
         this.masProduct = true;
      }*/
    });
    // //console.log('listProduct', this.pagarKabiCoin);
  };

  private date = (): string => {
    return format(new Date(), 'yyyyMMdd', {
      locale: es,
    });
  };

  private handleError = (error: any) => {
    let menssage = '';
    if (error?.error) {
      menssage = error.error.message;
    } else if (error?.message) {
      menssage = error.message;
    } else {
      menssage = error;
    }
    //console.log(error);
    this.swalService.swalError('Confirmar Pedido', menssage);
    // this..fire(
    //   'Carrito',
    //   'Lo sentimos, ocurrio un error al validar la informacion de su cesta.<br/><br/>Error: ' +
    //     menssage,
    //    'error',
    // );
    return throwError(error);
  };
}
